import { useAtom } from 'jotai';
import { maskAtom, PageMaskOpts } from './Data/Atoms';
import { AnimatePresence, motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import { onGlobalLoadingChange } from './Data/LoadingManager';

export const PageMask = () => {
    const [maskOptions] = useAtom( maskAtom );
    const [globalLoadingCount, setGlobalLoadingCount] = useState(0);

    useEffect(() => {
        const off = onGlobalLoadingChange(({ count }) => setGlobalLoadingCount(count));
        return off;
    }, []);

    // If a component explicitly sets a mask, that takes precedence
    const isExplicitMaskVisible = !!maskOptions?.showMask;
    const isGlobalMaskVisible = !isExplicitMaskVisible && globalLoadingCount > 0;
    if (!isExplicitMaskVisible && !isGlobalMaskVisible) {
        return null; // do not render anything if no mask is visible
    }

    if (isExplicitMaskVisible && !maskOptions?.showDotsLoader) {
        return (
            <div className="page-mask">
                <div className="mask-dialog">
                    <div className="d-flex flex-column align-items-center">
                        <h2 className="mt-3">{maskOptions.header}</h2>
                        {maskOptions?.subText && (
                            <p>{maskOptions.subText}</p>
                        )}
                    </div>
                    <br />
                    <div className="mask-loader w-100">
                        {/* Horizontal loader */}
                    </div>
                </div>
            </div>
        );
    }
    else{
        return <AnimatePresence>           
            <motion.div 
                className="page-mask-dots"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.15 }}
            >
                <div className="mask-dialog-dots">
                    <div className="mask-loader-container-dots">
                        {[0, 1, 2].map((index) => (
                            <motion.div
                                key={index}
                                className="mask-loader-dots"
                                animate={{
                                    scale: [1, 1.2, 1],
                                    opacity: [1, 0.5, 1]
                                }}
                                transition={{
                                    duration: 1,
                                    repeat: Infinity,
                                    delay: index * 0.2,
                                    ease: "easeInOut"
                                }}
                            />
                        ))}
                    </div>
                </div>
            </motion.div>         
        </AnimatePresence>
    }
}

